export const INSTRUMENTATION_PERIODS = [
  { title: 'Manual', value: 'manual' },
  { title: '3 month', value: 3 },
  { title: '6 month', value: 6 },
  { title: '12 month', value: 12 },
  { title: '24 month', value: 24 },
  { title: '36 month', value: 36 },
  { title: '48 month', value: 48 },
  { title: '60 month', value: 60 },
];

export const INSTRUMENTATION_STATUS = [
  { title: 'Active', value: 'active' },
  { title: 'Abeyance', value: 'abeyance' },
  { title: 'Inactive', value: 'inactive' },
  { title: 'On Order', value: 'on_order' },
  { title: 'OOS - Missing', value: 'oos_missing' },
  { title: 'OOS - Scrap', value: 'oos_scrap' },
  { title: 'OOS - Transferred', value: 'oos_transferred' },
];
